import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.dashboard2');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-dashboard2',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.dashboard2/view.scss */
:host {
  display: block;
  height: 100%;
  min-width: 0;
}

.d2l-shell {
  display: flex;
  width: 100%;
  height: 100vh;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  color: #152238;
  font-family: Inter, "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
}

.d2l-header {
  --d2l-actions-column: 90px;
  position: relative;
  z-index: 80;
  width: 100%;
  flex: 0 0 auto;
  border-bottom: 1px solid #e8edf3;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 10px rgba(15, 37, 66, 0.04);
}

.d2l-header-inner {
  display: flex;
  width: min(100%, 1600px);
  height: 82px;
  box-sizing: border-box;
  align-items: center;
  gap: 24px;
  margin: 0 auto;
  padding: 0 32px;
}

.d2l-brand {
  display: inline-flex;
  width: 200px;
  flex: 0 0 200px;
  align-items: center;
  gap: 8px;
}

.d2l-brand img {
  display: block;
  width: 126px;
  height: auto;
}

.d2l-brand strong {
  color: #051946;
  font-size: 16px;
  font-weight: 800;
  white-space: nowrap;
}

.d2l-navigation {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: center;
  gap: clamp(12px, 1.05vw, 16px);
  box-sizing: border-box;
  padding: 0 24px;
}

.d2l-nav-item {
  display: flex;
  height: 100%;
  min-width: 0;
  align-items: center;
  justify-content: center;
}

.d2l-nav-link {
  position: relative;
  display: inline-flex;
  height: 100%;
  align-items: center;
  color: #39465a;
  font-size: 16px;
  font-weight: 750;
  letter-spacing: -0.015em;
  text-decoration: none;
  white-space: nowrap;
}

.d2l-nav-link::after {
  position: absolute;
  right: 50%;
  bottom: 0;
  left: 50%;
  height: 3px;
  background: #176fd0;
  content: "";
  transition: right 0.18s ease, left 0.18s ease;
}

.d2l-nav-link:hover,
.d2l-nav-link.is-active {
  color: #0d5eaf;
}

.d2l-nav-link:hover::after,
.d2l-nav-link.is-active::after {
  right: 0;
  left: 0;
}

.d2l-actions {
  display: flex;
  width: var(--d2l-actions-column);
  min-width: 0;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.d2l-workspace-link,
.d2l-icon-button,
.d2l-menu-button {
  display: inline-flex;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce5ef;
  border-radius: 12px;
  background: #ffffff;
  color: #506077;
  text-decoration: none;
}

.d2l-workspace-link {
  width: 40px;
  gap: 7px;
  padding: 0;
  color: #155fae;
  font-size: 12px;
  font-weight: 750;
}

.d2l-workspace-link span,
.d2l-user-copy {
  display: none;
}

.d2l-icon-button,
.d2l-menu-button {
  width: 38px;
  padding: 0;
  font-size: 14px;
}

.d2l-workspace-link:hover,
.d2l-icon-button:hover,
.d2l-menu-button:hover {
  border-color: #aac7e8;
  background: #f1f7fe;
}

.d2l-user {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
  border-radius: 14px;
  padding: 4px;
  color: #4b596d;
  text-decoration: none;
}

.d2l-user:hover {
  background: #f5f8fc;
}

.d2l-user-avatar {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e8f2ff;
  color: #1268c4;
  font-size: 13px;
  font-weight: 800;
}

.d2l-user-copy {
  display: none;
  max-width: 110px;
  flex-direction: column;
}

.d2l-user-copy strong,
.d2l-user-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.d2l-user-copy strong {
  font-size: 12px;
}

.d2l-user-copy small {
  margin-top: 2px;
  color: #909cad;
  font-size: 12px;
}

.d2l-menu-button {
  display: none;
}

.d2l-mobile-menu {
  display: none;
}

.d2l-mega-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 75;
  width: 100%;
  border-top: 1px solid #edf1f5;
  border-bottom: 1px solid #e1e7ef;
  background: rgba(255, 255, 255, 0.99);
  box-shadow: 0 18px 34px rgba(16, 38, 67, 0.1);
}

.d2l-mega-inner {
  display: grid;
  width: min(100%, 1600px);
  min-height: 224px;
  box-sizing: border-box;
  grid-template-columns: 200px minmax(0, 1fr) var(--d2l-actions-column);
  gap: 24px;
  margin: 0 auto;
  padding: 14px 32px 18px;
}

.d2l-mega-grid {
  display: grid;
  min-width: 0;
  gap: clamp(12px, 1.05vw, 16px);
  box-sizing: border-box;
  padding: 0 24px;
}

.d2l-mega-column {
  min-width: 0;
  min-height: 188px;
  border-radius: 12px;
  padding: 13px 2px;
  transition: background-color 0.16s ease;
}

.d2l-mega-column.is-active {
  background: #f3f5f8;
}

.d2l-mega-column a {
  display: block;
  overflow: hidden;
  border-radius: 8px;
  padding: 7px 2px;
  color: #526074;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.4;
  text-decoration: none;
  text-align: center;
  overflow-wrap: normal;
  white-space: normal;
  word-break: keep-all;
}

.d2l-mega-column a:hover,
.d2l-mega-column a:focus-visible {
  outline: 0;
  background: #e8f2fe;
  color: #0d5eaf;
}

.d2l-main-surface {
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  background: #ffffff;
}

.d2l-global-loading {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.14);
  backdrop-filter: blur(4px);
}

@media (max-width: 1320px) {
  .d2l-header-inner {
    gap: 18px;
    padding: 0 24px;
  }
  .d2l-brand {
    width: 178px;
    flex-basis: 178px;
  }
  .d2l-brand img {
    width: 112px;
  }
  .d2l-navigation {
    gap: 14px;
    padding-right: 14px;
    padding-left: 14px;
  }
  .d2l-nav-link {
    font-size: 15px;
  }
  .d2l-workspace-link {
    width: 38px;
    padding: 0;
  }
  .d2l-mega-inner {
    grid-template-columns: 178px minmax(0, 1fr) var(--d2l-actions-column);
    gap: 18px;
    padding-right: 24px;
    padding-left: 24px;
  }
  .d2l-mega-grid {
    gap: 14px;
    padding-right: 14px;
    padding-left: 14px;
  }
}
@media (max-width: 1199px) {
  .d2l-header-inner {
    height: 68px;
    padding: 0 20px;
  }
  .d2l-navigation,
  .d2l-mega-menu,
  .d2l-workspace-link,
  .d2l-user {
    display: none;
  }
  .d2l-actions {
    margin-left: auto;
  }
  .d2l-menu-button {
    display: inline-flex;
  }
  .d2l-mobile-menu {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    border-top: 1px solid #edf1f6;
    background: #ffffff;
    padding: 14px 20px 18px;
    box-shadow: 0 16px 30px rgba(15, 37, 66, 0.1);
  }
  .d2l-mobile-menu a {
    display: flex;
    min-height: 48px;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid #e4eaf1;
    border-radius: 12px;
    background: #f8fafc;
    padding: 0 15px;
    color: #44546a;
    font-size: 14px;
    font-weight: 750;
    text-decoration: none;
  }
  .d2l-mobile-menu a[aria-current=page] {
    border-color: #bbd3ee;
    background: #edf5fe;
    color: #0d5eaf;
  }
  .d2l-mobile-menu i {
    color: #7b9dc2;
    font-size: 11px;
  }
}
@media (max-width: 520px) {
  .d2l-header-inner {
    padding: 0 14px;
  }
  .d2l-brand {
    width: 166px;
    flex-basis: 166px;
  }
  .d2l-brand img {
    width: 104px;
  }
  .d2l-mobile-menu {
    grid-template-columns: minmax(0, 1fr);
    padding: 12px 14px 16px;
  }
}
:host-context(html[data-theme=dark]) .d2l-shell,
:host-context(html[data-theme=dark]) .d2l-main-surface {
  background: #0b1523;
}

:host-context(html[data-theme=dark]) .d2l-header,
:host-context(html[data-theme=dark]) .d2l-mobile-menu,
:host-context(html[data-theme=dark]) .d2l-mega-menu {
  border-color: #28384b;
  background: rgba(12, 24, 39, 0.98);
}

:host-context(html[data-theme=dark]) .d2l-mega-column.is-active {
  background: #17263a;
}

:host-context(html[data-theme=dark]) .d2l-mega-column a {
  color: #b9c7d7;
}

:host-context(html[data-theme=dark]) .d2l-brand img {
  filter: brightness(0) invert(1);
}

:host-context(html[data-theme=dark]) .d2l-brand strong {
  color: #ffffff;
}

:host-context(html[data-theme=dark]) .d2l-nav-link,
:host-context(html[data-theme=dark]) .d2l-user,
:host-context(html[data-theme=dark]) .d2l-mobile-menu a {
  color: #c2cfdd;
}

:host-context(html[data-theme=dark]) .d2l-workspace-link,
:host-context(html[data-theme=dark]) .d2l-icon-button,
:host-context(html[data-theme=dark]) .d2l-menu-button,
:host-context(html[data-theme=dark]) .d2l-mobile-menu a {
  border-color: #33455a;
  background: #142235;
}

.nf-floating-chat {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 45;
  pointer-events: none;
}

.nf-floating-chat > * {
  pointer-events: auto;
}

.nf-floating-chat-launcher {
  position: relative;
  display: flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #b8cae1;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

.nf-floating-chat-launcher:hover {
  border-color: #2e6fae;
  box-shadow: 0 20px 52px rgba(46, 111, 174, 0.28);
  transform: translateY(-2px);
}

.nf-floating-chat-launcher:focus-visible {
  outline: 3px solid rgba(46, 111, 174, 0.24);
  outline-offset: 3px;
}

.nf-floating-chat-launcher-face {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

.nf-floating-chat-launcher-dot {
  position: absolute;
  right: 3px;
  bottom: 3px;
  display: inline-flex;
  width: 21px;
  min-width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #153e66;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.nf-floating-chat-panel {
  display: grid;
  width: min(390px, 100vw - 32px);
  height: min(740px, 100vh - 122px);
  max-height: min(740px, 100vh - 122px);
  grid-template-rows: auto minmax(300px, 1fr) auto auto;
  overflow: hidden;
  border: 1px solid #c8d6e8;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

.nf-floating-chat-header {
  display: flex;
  min-height: 66px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e8edf5;
  padding: 10px 12px 10px 14px;
}

.nf-floating-chat-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.nf-floating-chat-title strong,
.nf-floating-chat-title small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-floating-chat-title strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
}

.nf-floating-chat-title small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.nf-floating-chat-face-wrap {
  display: flex;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f7fbff;
}

.nf-floating-chat-face {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.nf-floating-chat-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
}

.nf-floating-chat-actions button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9e1ec;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
}

.nf-floating-chat-actions button:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-chat-actions svg {
  width: 16px;
  height: 16px;
}

.nf-floating-chat-body {
  min-height: 0;
  overflow-y: auto;
  background: #f7f9fc;
  padding: 14px;
}

.nf-floating-chat-message {
  width: fit-content;
  max-width: 88%;
  margin-bottom: 10px;
  border: 1px solid #d9e1ec;
  border-radius: 14px;
  background: #ffffff;
  padding: 9px 11px;
  color: #0f172a;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
}

.nf-floating-chat-message p {
  margin: 0;
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.58;
}

.nf-floating-chat-message.is-user {
  margin-left: auto;
  border-color: #153e66;
  background: #153e66;
  color: #ffffff;
  box-shadow: none;
}

.nf-floating-chat-message.is-error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.nf-floating-chat-runtime {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.nf-floating-chat-runtime span {
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f8fafc;
  padding: 3px 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.35;
}

.nf-floating-chat-runtime span.is-sample,
.nf-floating-chat-runtime span.is-warning {
  border-color: #f5c46b;
  background: #fffbeb;
  color: #92400e;
}

.nf-floating-chat-citations {
  display: grid;
  gap: 4px;
  margin-top: 8px;
  border-top: 1px solid #e8edf5;
  padding-top: 8px;
}

.nf-floating-chat-citations span {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.nf-floating-chat-links,
.nf-floating-chat-followups,
.nf-floating-chat-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.nf-floating-chat-links a,
.nf-floating-chat-followups button,
.nf-floating-chat-suggestions button {
  max-width: 100%;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #ffffff;
  padding: 5px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
}

.nf-floating-chat-links a:hover,
.nf-floating-chat-followups button:hover,
.nf-floating-chat-suggestions button:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-chat-suggestions {
  margin: 0;
  border-top: 1px solid #e8edf5;
  padding: 10px 12px 0;
}

.nf-floating-chat-message.is-loading {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 12px;
}

.nf-floating-chat-message.is-loading span {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #2e6fae;
  animation: nf-floating-chat-bounce 0.9s infinite ease-in-out;
}

.nf-floating-chat-message.is-loading span:nth-child(2) {
  animation-delay: 0.12s;
}

.nf-floating-chat-message.is-loading span:nth-child(3) {
  animation-delay: 0.24s;
}

.nf-floating-chat-composer {
  display: grid;
  gap: 8px;
  padding: 10px 12px 12px;
}

.nf-floating-chat-composer textarea {
  width: 100%;
  min-height: 58px;
  resize: none;
  border: 1px solid #c8d6e8;
  border-radius: 12px;
  background: #ffffff;
  padding: 9px 10px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.5;
}

.nf-floating-chat-composer textarea:focus {
  border-color: #2e6fae;
  box-shadow: 0 0 0 3px rgba(46, 111, 174, 0.12);
  outline: none;
}

.nf-floating-chat-composer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.nf-floating-chat-key-hint {
  margin-right: auto;
  color: #64748b;
  font-size: 12px;
  line-height: 1.3;
}

.nf-floating-chat-secondary,
.nf-floating-chat-submit {
  height: 34px;
  border-radius: 999px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-chat-secondary {
  border: 1px solid #d9e1ec;
  background: #ffffff;
  color: #475569;
}

.nf-floating-chat-submit {
  border: 1px solid #153e66;
  background: #153e66;
  color: #ffffff;
}

.nf-floating-chat-submit:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@keyframes nf-floating-chat-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
:host-context([data-theme=dark]) .nf-floating-chat-panel {
  border-color: rgba(148, 163, 184, 0.34);
  background: #0f172a;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.44);
}

:host-context([data-theme=dark]) .nf-floating-chat-header,
:host-context([data-theme=dark]) .nf-floating-chat-suggestions {
  border-color: rgba(148, 163, 184, 0.22);
}

:host-context([data-theme=dark]) .nf-floating-chat-body {
  background: #071321;
}

:host-context([data-theme=dark]) .nf-floating-chat-title strong,
:host-context([data-theme=dark]) .nf-floating-chat-message,
:host-context([data-theme=dark]) .nf-floating-chat-composer textarea {
  color: #e5eef8;
}

:host-context([data-theme=dark]) .nf-floating-chat-message,
:host-context([data-theme=dark]) .nf-floating-chat-actions button,
:host-context([data-theme=dark]) .nf-floating-chat-composer textarea,
:host-context([data-theme=dark]) .nf-floating-chat-secondary,
:host-context([data-theme=dark]) .nf-floating-chat-links a,
:host-context([data-theme=dark]) .nf-floating-chat-followups button,
:host-context([data-theme=dark]) .nf-floating-chat-suggestions button {
  border-color: rgba(148, 163, 184, 0.28);
  background: #111c2e;
}

@media (max-width: 640px) {
  .nf-floating-chat {
    right: 12px;
    bottom: 14px;
    left: 12px;
  }
  .nf-floating-chat-launcher {
    margin-left: auto;
  }
  .nf-floating-chat-panel {
    width: 100%;
    height: calc(100vh - 86px);
    max-height: calc(100vh - 86px);
    border-radius: 14px;
  }
}`],
})
export class LayoutDashboard2Component implements OnInit {
    public theme: string = 'light';
    public mobileMenuOpen: boolean = false;
    public megaMenuOpen: boolean = false;
    public activeMenuId: string = '';
    public navigationItems: any[] = [];
    public menuGridColumns: string = '';
    public floatingChatOpen: boolean = false;
    public floatingChatInput: string = '';
    public floatingChatAsking: boolean = false;
    public floatingChatMessages: any[] = [
        {
            role: 'assistant',
            content: 'NanoFab Studio와 공정 데이터 질문을 도와드릴게요.',
            followups: ['이 사이트에서 무엇을 할 수 있어?', 'Lot A13 수율 하락 원인을 알려줘', 'AI 인터페이스 기능을 알려줘']
        }
    ];
    public floatingChatSuggestions: string[] = [
        '이 사이트에서 무엇을 할 수 있어?',
        'Lot A13 수율 하락 원인을 알려줘',
        'AI 인터페이스 기능을 알려줘'
    ];
    private readonly themeStorageKey: string = 'nanofab.theme';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.navigationItems = this.buildNavigationItems();
        this.menuGridColumns = this.buildMenuGridColumns();
        this.applyTheme(this.detectTheme());
    }

    @HostListener('document:keydown.escape')
    public async handleEscape() {
        if (!this.mobileMenuOpen && !this.megaMenuOpen) return;
        this.mobileMenuOpen = false;
        this.megaMenuOpen = false;
        this.activeMenuId = '';
        await this.service.render();
    }

    @HostListener('window:resize')
    public async handleResize() {
        if (window.innerWidth < 1200) await this.closeMegaMenu();
        if (!this.mobileMenuOpen || window.innerWidth < 1200) return;
        this.mobileMenuOpen = false;
        await this.service.render();
    }

    private buildNavigationItems() {
        const items = [
            {
                id: 'dashboard', route: '/dashboard2', label: '대시보드', match: ['/dashboard2', '/dashboard'],
                children: [{ route: '/dashboard2', label: '대시보드 홈' }]
            },
            {
                id: 'data', route: '/agent/history', label: 'Agent 데이터 허브', match: ['/agent/history', '/agent/lot-history', '/agent/trace'],
                children: [{ route: '/agent/history', label: '데이터 허브' }]
            },
            {
                id: 'agent', route: '/agent/chat', label: '지능형 분석 서비스', match: ['/agent/chat'],
                children: [{ route: '/agent/chat', label: 'AI Agent 대화' }]
            },
            {
                id: 'analysis', route: '/agent/analysis', label: '데이터 분석 환경', match: ['/agent/analysis', '/agent/visualization', '/agent/workflows'],
                children: [
                    { route: '/agent/analysis', label: '예측·추론' },
                    { route: '/agent/visualization', label: '시각화·보고서' },
                ]
            },
        ];
        if (!this.isAdmin()) {
            items.push({
                id: 'training', route: '/agent/training', label: 'AI 반도체 공정 교육', match: ['/agent/training'],
                children: [{ route: '/agent/training', label: '교육 과정' }]
            });
        }
        if (this.isAdmin()) {
            items.push({
                id: 'settings', route: '/agent/admin', label: '설정', match: ['/agent/admin'],
                children: [
                    { route: '/agent/admin', label: 'LLM 모델' },
                    { route: '/agent/admin', query: { workspace: 'document-ai' }, label: '문서 AI·데이터 모델' },
                    { route: '/agent/admin', query: { workspace: 'operations' }, label: '운영·보안' },
                ]
            });
        }
        return items;
    }

    private buildMenuGridColumns() {
        const weights: any = {
            dashboard: 0.85,
            data: 1.35,
            agent: 1.35,
            analysis: 1.2,
            training: 1.35,
            settings: 0.55,
        };
        return this.navigationItems
            .map((item: any) => `minmax(0, ${weights[item.id] || 1}fr)`)
            .join(' ');
    }

    public isActive(item: any) {
        const path = typeof location === 'undefined' ? '' : location.pathname;
        return (item?.match || [item?.route]).some((route: string) => path.indexOf(route) === 0);
    }

    public navItemClass(item: any) {
        return this.isActive(item) || this.activeMenuId === item?.id ? 'd2l-nav-link is-active' : 'd2l-nav-link';
    }

    public async openMegaMenu(id: string) {
        if (typeof window !== 'undefined' && window.innerWidth < 1200) return;
        if (this.megaMenuOpen && this.activeMenuId === id) return;
        this.activeMenuId = id;
        this.megaMenuOpen = true;
        await this.service.render();
    }

    public async closeMegaMenu() {
        if (!this.megaMenuOpen && !this.activeMenuId) return;
        this.megaMenuOpen = false;
        this.activeMenuId = '';
        await this.service.render();
    }

    public megaMenuColumnClass(item: any) {
        return this.activeMenuId === item?.id ? 'd2l-mega-column is-active' : 'd2l-mega-column';
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public userInitial() {
        const name = String(this.service.auth.session?.name || this.service.auth.session?.email || 'U').trim();
        return name.charAt(0).toUpperCase() || 'U';
    }

    public userRoleLabel() {
        return this.isAdmin() ? 'Administrator' : 'Member';
    }

    public floatingChatClass() {
        return { 'is-open': this.floatingChatOpen };
    }

    public async toggleFloatingChat(event?: Event) {
        if (event) event.stopPropagation();
        this.floatingChatOpen = !this.floatingChatOpen;
        await this.service.render();
        if (this.floatingChatOpen) this.scrollFloatingChatToBottom();
    }

    public async closeFloatingChat(event?: Event) {
        if (event) event.stopPropagation();
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public async resetFloatingChat() {
        this.floatingChatMessages = [{
            role: 'assistant',
            content: '새 질문을 입력해 주세요. 사이트 안내, 공정 데이터, AI 분석 기능을 바로 확인할 수 있습니다.',
            followups: this.floatingChatSuggestions
        }];
        this.floatingChatInput = '';
        await this.service.render();
    }

    public async selectFloatingSuggestion(text: string) {
        this.floatingChatInput = text;
        await this.floatingChatAsk();
    }

    public async floatingChatAsk() {
        const message = String(this.floatingChatInput || '').trim();
        if (!message || this.floatingChatAsking) return;

        this.floatingChatMessages.push({ role: 'user', content: message });
        this.floatingChatInput = '';
        this.floatingChatAsking = true;
        this.trimFloatingChatMessages();
        await this.service.render();
        this.scrollFloatingChatToBottom();

        try {
            const response: any = await this.service.request.post('/wiz/api/page.agent/ask', { message, source: 'floating' });
            if (!response || response.code !== 200) {
                throw new Error(response?.data?.message || response?.message || '질의를 처리하지 못했습니다.');
            }
            const data = this.floatingPayload(response.data);
            this.floatingChatMessages.push(this.floatingAssistantMessage(data, message));
        } catch (error: any) {
            this.floatingChatMessages.push({
                role: 'error',
                content: error?.message || '질의를 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.'
            });
        }

        this.floatingChatAsking = false;
        this.trimFloatingChatMessages();
        await this.service.render();
        this.scrollFloatingChatToBottom();
    }

    public async openAgentChatFromFloating() {
        this.service.href('/agent/chat');
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public floatingMessageClass(message: any) {
        if (message?.role === 'user') return 'is-user';
        if (message?.role === 'error') return 'is-error';
        return 'is-assistant';
    }

    public handleFloatingChatKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey || (event as any).isComposing) return;
        event.preventDefault();
        void this.floatingChatAsk();
    }

    public floatingRuntimeItems(message: any) {
        const items: any[] = [];
        const scope = String(message?.dataScope || '');
        if (scope === 'sample') {
            items.push({ label: `샘플 데이터${message?.dataAsOf ? ' · ' + message.dataAsOf + ' 기준' : ''}`, tone: 'sample' });
        } else if (scope === 'no_data') {
            items.push({ label: '일치하는 근거 데이터 없음', tone: 'warning' });
        }
        if (message?.llm?.fallback === true || message?.llm?.degraded === true) {
            items.push({ label: '대체 응답 사용', tone: 'warning' });
        }
        return items;
    }

    private floatingPayload(data: any) {
        if (data && data.data) return data.data;
        return data || {};
    }

    private floatingAssistantMessage(data: any, question: string) {
        return {
            role: 'assistant',
            question,
            content: data?.answer || '답변을 생성하지 못했습니다.',
            intent: data?.intent || '',
            dataScope: data?.dataScope || '',
            dataAsOf: data?.dataAsOf || '',
            source: data?.source || '',
            llm: data?.llm || null,
            citations: (data?.citations || []).slice(0, 3),
            deepLinks: (data?.deepLinks || []).slice(0, 3),
            followups: (data?.followups || []).slice(0, 3)
        };
    }

    private trimFloatingChatMessages() {
        if (this.floatingChatMessages.length > 16) {
            this.floatingChatMessages = this.floatingChatMessages.slice(this.floatingChatMessages.length - 16);
        }
    }

    private scrollFloatingChatToBottom() {
        setTimeout(() => {
            const body = document.querySelector('.nf-floating-chat-body') as HTMLElement | null;
            if (body) body.scrollTop = body.scrollHeight;
        }, 0);
    }

    public async toggleMobileMenu(event?: Event) {
        if (event) event.stopPropagation();
        await this.closeMegaMenu();
        this.mobileMenuOpen = !this.mobileMenuOpen;
        await this.service.render();
    }

    public async closeMobileMenu() {
        this.mobileMenuOpen = false;
        await this.service.render();
    }

    public async toggleTheme(event?: Event) {
        if (event) event.stopPropagation();
        this.applyTheme(this.theme === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    public themeLabel() {
        return this.theme === 'dark' ? '화이트 모드로 전환' : '다크 모드로 전환';
    }

    private detectTheme() {
        try {
            const saved = localStorage.getItem(this.themeStorageKey);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch (_error) { }
        return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    private applyTheme(theme: string) {
        this.theme = theme === 'dark' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', this.theme);
        document.documentElement.style.colorScheme = this.theme;
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', this.theme === 'dark' ? '#071321' : '#ffffff');
        try {
            localStorage.setItem(this.themeStorageKey, this.theme);
        } catch (_error) { }
    }
}

export default LayoutDashboard2Component;